import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Capacitor } from '@capacitor/core';

import { ENOUGH_APP_STORE_URL, ENOUGH_PLAY_STORE_URL } from '@shared/constants/appStoreUrls';

function getStoreUrl(): string {
  return Capacitor.getPlatform() === 'ios' ? ENOUGH_APP_STORE_URL : ENOUGH_PLAY_STORE_URL;
}

export const UpdateBanner: React.FC<{ isNative: boolean }> = ({ isNative }) => (
  <div className="bg-stream text-growth px-4 py-3" style={{ paddingTop: `max(0.75rem, var(--sat))` }}>
    <div className="flex items-center justify-center gap-3 max-w-4xl mx-auto text-sm font-sans">
      <RefreshCw className="w-4 h-4 shrink-0" />
      <span>A new version is available.</span>
      {isNative ? (
        <a
          href={getStoreUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="text-growth underline underline-offset-2 font-medium"
        >
          Update
        </a>
      ) : (
        <button
          onClick={() => window.location.reload()}
          className="text-growth underline underline-offset-2 font-medium"
        >
          Refresh
        </button>
      )}
    </div>
  </div>
);
